/*
 * @Author: Teemo Ding
 * @Date: 2021-07-30 11:32:18
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-03 13:22:00
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/FlashSaleBarStyle/index.tsx
 */
import React from 'react';

import { store } from 'src/store';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { suffix } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getFlashSaleBarStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFlashSaleBarStyleChange,
  onFlashSaleBarStyleReset,
} from '../slice';

const idSet = {
  comingSoonStatusBackgroundColour: suffix + 'statusSectionBackgroundColour',
  comingSoonStatusTextColour: suffix + 'comingSoonStatusTextColour',
  comingSoonPriceBackgroundColour: suffix + 'comingSoonPriceBackgroundColour',
  comingSoonPriceTextColour: suffix + 'comingSoonPriceTextColour',
  saleNowStatusBackgroundColour: suffix + 'saleNowStatusBackgroundColour',
  saleNowStatusTextColour: suffix + 'saleNowStatusTextColour',
  salesNowCountDownTimerBackgroundColour:
    suffix + 'salesNowCountDownTimerBackgroundColour',
  salesNowCountDownTimerTextColour: suffix + 'salesNowCountDownTimerTextColour',
  saleNowPriceBackgroundColour: suffix + 'saleNowPriceBackgroundColour',
  saleNowPriceTextColour: suffix + 'saleNowPriceTextColour',
};
const FlashSaleBarStyle = (props) => {
  const { data } = props;
  const {
    comingSoonPrice,
    comingSoonStatus,
    saleNowStatus,
    salesNowCountDownTimer,
    saleNowPrice,
  } = data || {};

  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const handleFlashSaleBarStyleChange = (key, data, saleNow) => {
    _d(
      onFlashSaleBarStyleChange({
        key: key,
        data,
        saleNow,
      }),
    );
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n('general.status')}
          bottomTitle={getI18n(
            'salesChannelContent.index.comingSoon',
          )}></ItemWrapper>
        <ItemWrapper
          id={idSet.comingSoonStatusBackgroundColour}
          title={getI18n(
            'salesChannelContent.index.statusSectionBackgroundColour',
          )}>
          <ColorPicker
            id={idSet.comingSoonStatusBackgroundColour}
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'comingSoonStatus',
                {
                  backgroundColor: color,
                },
                false,
              )
            }
            multi
            color={comingSoonStatus.backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.comingSoonStatusTextColour}
          title={getI18n('salesChannelContent.index.statusTextColour')}>
          <ColorPicker
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'comingSoonStatus',
                {
                  textColor: color,
                },
                false,
              )
            }
            multi
            id={idSet.comingSoonStatusTextColour}
            color={comingSoonStatus.textColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.comingSoonPriceBackgroundColour}
          title={getI18n(
            'salesChannelContent.index.priceSectionBackgroundColour',
          )}>
          <ColorPicker
            id={idSet.comingSoonPriceBackgroundColour}
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'comingSoonPrice',
                {
                  backgroundColor: color,
                },
                false,
              )
            }
            multi
            color={comingSoonPrice.backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.comingSoonPriceTextColour}
          title={getI18n('salesChannelContent.index.priceSectionTextColour')}>
          <ColorPicker
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'comingSoonPrice',
                {
                  textColor: color,
                },
                false,
              )
            }
            multi
            id={idSet.comingSoonPriceTextColour}
            color={comingSoonPrice.textColor}
          />
        </ItemWrapper>
      </Section>
      <Section>
        <ItemWrapper
          title={getI18n('general.status')}
          bottomTitle={getI18n(
            'salesChannelContent.index.saleNow',
          )}></ItemWrapper>
        <ItemWrapper
          id={idSet.saleNowStatusBackgroundColour}
          title={getI18n(
            'salesChannelContent.index.statusSectionBackgroundColour',
          )}>
          <ColorPicker
            id={idSet.saleNowStatusBackgroundColour}
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'saleNowStatus',
                {
                  backgroundColor: color,
                },
                true,
              )
            }
            multi
            color={saleNowStatus.backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.saleNowStatusTextColour}
          title={getI18n('salesChannelContent.index.statusTextColour')}>
          <ColorPicker
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'saleNowStatus',
                {
                  textColor: color,
                },
                true,
              )
            }
            multi
            id={idSet.saleNowStatusTextColour}
            color={saleNowStatus.textColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.salesNowCountDownTimerBackgroundColour}
          title={getI18n(
            'salesChannelContent.index.countDownTimerBackgroundColour',
          )}>
          <ColorPicker
            id={idSet.salesNowCountDownTimerBackgroundColour}
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'salesNowCountDownTimer',
                {
                  backgroundColor: color,
                },
                true,
              )
            }
            multi
            color={salesNowCountDownTimer.backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.salesNowCountDownTimerTextColour}
          title={getI18n('salesChannelContent.index.countDownTimerTextColour')}>
          <ColorPicker
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'salesNowCountDownTimer',
                {
                  textColor: color,
                },
                true,
              )
            }
            multi
            id={idSet.salesNowCountDownTimerTextColour}
            color={salesNowCountDownTimer.textColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.saleNowPriceBackgroundColour}
          title={getI18n(
            'salesChannelContent.index.priceSectionBackgroundColour',
          )}>
          <ColorPicker
            id={idSet.saleNowPriceBackgroundColour}
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'saleNowPrice',
                {
                  backgroundColor: color,
                },
                true,
              )
            }
            multi
            color={saleNowPrice.backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.saleNowPriceTextColour}
          title={getI18n('salesChannelContent.index.priceSectionTextColour')}>
          <ColorPicker
            onChange={(color) =>
              handleFlashSaleBarStyleChange(
                'saleNowPrice',
                {
                  textColor: color,
                },
                true,
              )
            }
            multi
            id={idSet.saleNowPriceTextColour}
            color={saleNowPrice.textColor}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(FlashSaleBarStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.flashSaleBarStyle,
  getContent: getFlashSaleBarStyle,
  title: getI18nFromGeneral('general.hOCTitle.flashSaleBarStyle'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //validation: validateSeoSetting,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onFlashSaleBarStyleReset());
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
